import React from 'react';
import './ProgressLoader.css';

function ProgressLoader({ progress, message }) {
  return (
    <div className="progress-loader-overlay">
      <div className="progress-loader-container">
        <h3 className="progress-loader-title">Processing...</h3>

        <div className="progress-bar-container">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <div className="progress-percentage">
          {Math.round(progress)}%
        </div>

        <p className="progress-message">
          {message}
          {progress < 100 && <span className="progress-spinner"></span>}
        </p>
      </div>
    </div>
  );
}

export default ProgressLoader;
